export const SESSION_EXPIRED_EVENT = 'skillbridger:session-expired'

export function notifySessionExpired() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT))
  }
}

export function handleSessionExpiredResponse(
  response: Pick<Response, 'status'>,
  body?: { code?: string } | null
) {
  if (response.status === 401 && body?.code === 'SESSION_EXPIRED') {
    notifySessionExpired()
    return true
  }
  return false
}
